import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	list: []
};

const personasSlice = createSlice({
	name: 'personas',
	initialState,
	reducers: {
		setPersonas(state, action) {
			state.list = action.payload || [];
		},
		clearPersonas(state) {
			state.list = [];
		}
	}
});

export const { setPersonas, clearPersonas } = personasSlice.actions;
export const selectPersonas = (state) => state.personas.list;
export default personasSlice.reducer;
